import { FieldValues, ArrayPath, useFormContext, useFieldArray } from "react-hook-form";

interface ArrayFieldsProps<TFieldValues extends FieldValues> {
  name: ArrayPath<TFieldValues>;
  children: (fields: { fields: any[] }) => React.ReactNode;
}

export const ArrayFields = <TFieldValues extends FieldValues>({
  name,
  children,
}: ArrayFieldsProps<TFieldValues>) => {
  const { control } = useFormContext<TFieldValues>();
  const { fields } = useFieldArray({
    control,
    name,
  });

  return <>{children({ fields })}</>;
};

export default {ArrayFields};